(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function (ElementProto) {
  if (typeof ElementProto.matches !== "function") {
    ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
      var element = this;
      var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
      var index = 0;
      while (elements[index] && elements[index] !== element) {
        ++index;
      }
      return Boolean(elements[index]);
    };
  }
  if (typeof ElementProto.closest !== "function") {
    ElementProto.closest = function closest(selector) {
      var element = this;
      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
      }
      return null;
    };
  }
})(window.Element.prototype);

},{}],2:[function(require,module,exports){
"use strict";

require("core-js/es/object/assign.js");
require("core-js/es/array/find.js");
require("core-js/es/array/find-index.js");
require("core-js/es/array/fill.js");
require("core-js/es/array/includes.js");
require("core-js/es/array/from.js");
require("./closest.js");
require("core-js/es/map");
require("core-js/es/set");
require("whatwg-fetch");
var _promisePolyfill = _interopRequireDefault(require("promise-polyfill"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// for react 16
// https://facebook.github.io/react/blog/2017/09/26/react-v16.0.html#javascript-environment-requirements

// window.fetch and window.Promise

if (!window.Promise) {
  window.Promise = _promisePolyfill["default"];
}

},{"./closest.js":1,"core-js/es/array/fill.js":"core-js/es/array/fill.js","core-js/es/array/find-index.js":"core-js/es/array/find-index.js","core-js/es/array/find.js":"core-js/es/array/find.js","core-js/es/array/from.js":"core-js/es/array/from.js","core-js/es/array/includes.js":"core-js/es/array/includes.js","core-js/es/map":"core-js/es/map","core-js/es/object/assign.js":"core-js/es/object/assign.js","core-js/es/set":"core-js/es/set","promise-polyfill":"promise-polyfill","whatwg-fetch":"whatwg-fetch"}]},{},[2]);
